export const PUBLIC_LINK_BASE =
  (import.meta.env.VITE_PUBLIC_LINK_BASE as string) || 'https://safaro.uz/l';

export const CHANNEL_OPTIONS = [
  { value: 'TELEGRAM', label: 'Telegram' },
  { value: 'FACEBOOK', label: 'Facebook' },
  { value: 'INSTAGRAM', label: 'Instagram' },
  { value: 'WHATSAPP', label: 'WhatsApp' },
  { value: 'EMAIL', label: 'Email' },
  { value: 'SMS', label: 'SMS' },
  { value: 'QR', label: 'QR Code' },
  { value: 'OTHER', label: 'Boshqa' },
];

export const CHANNEL_COLORS: Record<string, string> = {
  TELEGRAM: 'blue',
  FACEBOOK: 'geekblue',
  INSTAGRAM: 'magenta',
  WHATSAPP: 'green',
  EMAIL: 'orange',
  SMS: 'purple',
  QR: 'cyan',
  OTHER: 'default',
};
